import axios from "axios";
import {createUrlParams} from "../utils/urlParams";

export const getIncidents = async (data) => {
    const urlParams = createUrlParams(data)
    const url = `/api/v1/incidents?${urlParams.toString()}`;

    const res = await axios.get(url);
    return res.data;
}


export const getIncident = async (incidentId) => {
    const url = `/api/v1/incidents/${incidentId}`;
    const res = await axios.get(url);
    return res.data;
}


export const getIncidentPre2021 = async (incidentId) => {
    const url = `/api/v1/incidents_pre2021/${incidentId}`;
    const res = await axios.get(url);
    return res.data;
}


export const createIncident = async (data) => {
    const url = `/api/v1/incidents`;
    const res = await axios.post(url, data);
    return res.data;
}


export const updateIncident = async (incidentId, data) => {
    const url = `/api/v1/incidents/${incidentId}`;
    const res = await axios.put(url, data);
    return res.data;
}

export const updateIncidentPre2021 = async (incidentId, data) => {
    const url = `/api/v1/incidents_pre2021/${incidentId}`;
    const res = await axios.put(url, data);
    return res.data;
}

export const deleteIncident = async (id) => {
    const url = `/api/v1/incidents/${id}`;
    const res = await axios.delete(url);
    return res.data;
}

export const deleteIncidentPre2021 = async (id) => {
    const url = `/api/v1/incidents_pre2021/${id}`;
    const res = await axios.delete(url);
    return res.data;
}


export const exportIncidents = async (data) => {
    const urlParams = createUrlParams(data)
    const url = `/api/v1/incidents/export?${urlParams.toString()}`;
    const res = await axios.get(url, {responseType: 'blob'});
    const disposition = res.headers["content-disposition"];
    const fileName = disposition.split("filename=")[1];
    return {data: res.data, fileName};
}


export const exportPeopleCaught = async (data) => {
    const urlParams = createUrlParams(data)
    const url = `/api/v1/incidents/export_people_caught?${urlParams.toString()}`;
    const res = await axios.get(url, {responseType: 'blob'});
    const disposition = res.headers["content-disposition"];
    const fileName = disposition.split("filename=")[1];
    return {data: res.data, fileName};
}

export const getIncidentTotals = async (data) => {
    const urlParams = createUrlParams(data)
    const url = `/api/v1/incidents/totals?${urlParams.toString()}`;
    const res = await axios.get(url);
    return res.data;
}